var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BModal',{ref:"modal-preview-img",attrs:{"centered":"","hide-header":"","hide-footer":"","size":"xl"}},[_c('BRow',{staticClass:"justify-content-center my-4"},[_c('BImg',{attrs:{"src":_vm.img}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }